<div [@routerTransition]>
    <div class="content d-flex flex-column flex-column-fluid">
        <div [class]="containerClass">
            <div class="card card-custom gutter-b">
                <div class="card-body">
                    <div class="row m-3">
                        <div class="col-xs-12">
                            <h1 class="pb-4">{{ 'Imprint' | localize }}</h1>
                            <div [innerHtml]="l('ImprintContent')"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
